import { ChakraProvider } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import useApiFetch from '@/hooks/useApiFetch';
import Seminars, { SeminarContentType } from '@/services/seminars';
import { chakraExtendedTheme } from '@/styles/theme';
import { FetchApiIds } from '@/types';
import SeminarDetailsComponent from './SeminarDetails.component';

const SeminarDetailsPage = function (): JSX.Element {
  const { id } = useParams();
  const getSeminarByIdResponse = useApiFetch<SeminarContentType, void>(
    [FetchApiIds.SEMINAR_BY_ID, id],
    async () => Seminars.getSeminarById(id as string)
  );

  const seminarDetailsData = getSeminarByIdResponse.data as SeminarContentType;

  return (
    <ChakraProvider theme={chakraExtendedTheme}>
      <SeminarDetailsComponent
        {...seminarDetailsData}
        isLoading={getSeminarByIdResponse.isLoading}
        notFound={getSeminarByIdResponse.isError}
      />
    </ChakraProvider>
  );
};

export default SeminarDetailsPage;
